// Presentation only. Never derive applied credit from receipts or wallet history.
const nonnegativeMoney = value => Number.isSafeInteger(value) && value >= 0;
export const isOpenPo = po => ['OPEN', 'AKTIF', 'BERJALAN'].includes(po?.status);
export function financialBalanceStatus(summary, shipping, po) {
  const unavailable = { state: 'unavailable', label: 'Data tagihan belum tersedia', amount: null };
  if (!summary || typeof summary !== 'object') return unavailable;
  // Before DAPAT the legacy API deliberately reports a zero balance. It is not settled.
  if (summary.pending_barang_dapat === true || summary.finance_state === 'pending_goods') {
    const closed = po?.status === 'CLOSED' || po?.status === 'CLOSE';
    return { state: closed ? 'no_goods' : 'pending_goods',
      label: closed ? 'Tidak ada barang DAPAT' : 'Menunggu barang didapat', amount: null };
  }
  if (summary.finance_state !== 'available' || summary.pending_barang_dapat !== false) return unavailable;
  const { total_belanja: goods, ongkir: fee, total_payment: paid, sisa_tagihan: balance, diskon = 0 } = summary;
  // Validate, never replace, authoritative monetary outputs. No rounding-to-zero rule.
  if (![goods, fee, paid, diskon].every(nonnegativeMoney) || !Number.isSafeInteger(balance) ||
      !Number.isSafeInteger(goods + fee) || diskon > goods + fee || goods + fee - diskon - paid !== balance) return unavailable;
  const ready = shipping?.fee_state === 'charged' ? fee > 0
    : (shipping?.fee_state === 'free' || shipping?.fee_state === 'fully_subsidized') && fee === 0;
  if (!ready && !isOpenPo(po)) return { state: 'pending_shipping', label: 'Menunggu ongkir', amount: null };
  if (balance > 0) return { state: 'underpaid', label: 'Kurang bayar', amount: balance };
  if (balance < 0) return { state: 'overpaid', label: 'Lebih bayar', amount: Math.abs(balance) };
  return { state: 'paid', label: 'Lunas', amount: null };
}
